import _styled from '@emotion/styled/base';
import { spacing, text, border } from '@hubble/tokens/web';

const INPUT_SIZE_MAP = {
  xs: {
    paddingInline: spacing[4],
    fontSize: text.typesets.body.xsBold.fontSize,
    fontWeight: text.typesets.body.xsBold.fontWeight,
    lineHeight: text.typesets.body.xsBold.lineHeight
  },
  sm: {
    paddingInline: spacing[8],
    fontSize: text.typesets.body.xsBold.fontSize,
    fontWeight: text.typesets.body.xsBold.fontWeight,
    lineHeight: text.typesets.body.xsBold.lineHeight
  },
  md: {
    paddingInline: spacing[12],
    fontSize: text.typesets.body.smBold.fontSize,
    fontWeight: text.typesets.body.smBold.fontWeight,
    lineHeight: text.typesets.body.smBold.lineHeight
  },
  lg: {
    paddingInline: spacing[16],
    fontSize: text.typesets.body.mdBold.fontSize,
    fontWeight: text.typesets.body.mdBold.fontWeight,
    lineHeight: text.typesets.body.mdBold.lineHeight
  }
};
const VARIANT_STYLES = {
  filled: theme => ({
    backgroundColor: theme.colorScheme.action.background.secondary.neutral.enabled
  }),
  transparent: () => ({})
};
const StepperStyles = _styled("div", {
  target: "e1pgbmfe1"
})(({
  theme,
  variant
}) => ({
  display: 'flex',
  width: 'fit-content',
  borderRadius: border.radius.full,
  ...VARIANT_STYLES[variant](theme)
}));
const StepperInputStyles = _styled("input", {
  target: "e1pgbmfe0"
})(({
  inputSize,
  theme
}) => ({
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  fontFeatureSettings: "'tnum' on, 'lnum' on",
  paddingInline: INPUT_SIZE_MAP[inputSize].paddingInline,
  fontSize: INPUT_SIZE_MAP[inputSize].fontSize,
  fontWeight: INPUT_SIZE_MAP[inputSize].fontWeight,
  lineHeight: INPUT_SIZE_MAP[inputSize].lineHeight,
  ':disabled': {
    color: theme.colorScheme.content.disabled
  }
}));

export { StepperInputStyles, StepperStyles };
